// Cart Page Warranty Toggle
;(function () {
  // Use product handle instead of hard-coded ID
  const WARRANTY_PRODUCT_HANDLE = "brave-star-shipping-warranty"
  const TOGGLE_ID = "cart-page-protection-toggle"

  // Toggle handler for cart page
  function handleToggleClick() {
    const toggle = document.getElementById(TOGGLE_ID)
    if (!toggle) return
    
    // Prevent multiple clicks
    if (toggle.disabled) return
    toggle.disabled = true

    // Get current state from toggle
    const hasWarranty = false
    
    // Toggle warranty state
    if (hasWarranty) {
      removeWarranty()
    } else {
      // addWarranty()
    }
  }

  // Add warranty product to cart - dynamically gets the correct variant ID
  async function addWarranty() {
    try {
      // Get real-time warranty variant ID based on current cart total
      const variantId = await getCartTotal();
      
      if (!variantId) {
        console.error("[CartPageWarranty] Could not get valid warranty variant ID");
        const toggle = document.getElementById(TOGGLE_ID);
        if (toggle) toggle.disabled = false;
        return;
      }
      
      console.log("[CartPageWarranty] Adding warranty with variant ID:", variantId);
      
      // Add warranty item to cart
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      });
      
      if (!res.ok) {
        const errText = await res.text();
        console.error("[CartPageWarranty] Failed to add warranty:", errText);
        const toggle = document.getElementById(TOGGLE_ID);
        if (toggle) toggle.disabled = false;
        return;
      }
      
      // Reload the page to reflect changes
      window.location.reload();
    } catch (err) {
      console.error("[CartPageWarranty] Error adding warranty:", err);
      const toggle = document.getElementById(TOGGLE_ID);
      if (toggle) toggle.disabled = false;
    }
  }

  // Remove warranty product from cart
  async function removeWarranty() {
    try {
      // First find the warranty in the cart
      const cartResponse = await fetch('/cart.js')
      const cart = await cartResponse.json()
      
      // Find all warranty items by product handle
      const warrantyItems = cart.items.filter(item => item.handle === WARRANTY_PRODUCT_HANDLE);
      
      if (warrantyItems.length > 0) {
        console.log("[CartPageWarranty] Removing warranty items:", warrantyItems.length);
        
        // Remove each warranty item
        for (const item of warrantyItems) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        }
        
        // Reload the page to reflect changes
        window.location.reload();
      } else {
        console.warn("[CartPageWarranty] Warranty not found in cart but toggle showed it active")
        const toggle = document.getElementById(TOGGLE_ID)
        if (toggle) {
          toggle.setAttribute("data-has-warranty", "false")
          toggle.setAttribute("aria-pressed", "false")
          renderToggle(false)
          toggle.disabled = false
        }
      }
    } catch (err) {
      console.error("[CartPageWarranty] Error removing warranty:", err)
      const toggle = document.getElementById(TOGGLE_ID)
      if (toggle) toggle.disabled = false
    }
  }

  // Check if warranty product is in cart
  async function checkWarrantyInCart() {
    try {
      const resp = await fetch("/cart.js")
      const cart = await resp.json()
      
      // Check if any item in the cart has the warranty product handle
      return cart.items.some(item => {
        return item.handle === WARRANTY_PRODUCT_HANDLE;
      });
    } catch (error) {
      console.error("[CartPageWarranty] Error checking warranty in cart:", error);
      return false;
    }
  }
  
  // Update toggle appearance based on state
  function renderToggle(hasWarranty) {
    const toggle = document.getElementById(TOGGLE_ID)
    if (!toggle) return
    
    toggle.setAttribute("data-has-warranty", hasWarranty ? "true" : "false")
    toggle.setAttribute("aria-pressed", hasWarranty ? "true" : "false")
    
    toggle.innerHTML = hasWarranty 
      ? `
      <span style="font-size:0.95em;color:#86c7d9;font-weight:600;">On</span>
      <span style="display:inline-block;width:32px;height:18px;background:#86c7d9;border-radius:9px;position:relative;vertical-align:middle;">
        <span style="display:block;width:16px;height:16px;background:#ffffff;border:1px solid #86c7d9;border-radius:50%;position:absolute;top:1px;left:15px;transition:left 0.2s;"></span>
      </span>
      `
      : `
      <span style="font-size:0.95em;color:#86c7d9;;font-weight:600;">Off</span>
      <span style="display:inline-block;width:32px;height:18px;background:#86c7d9;border-radius:9px;position:relative;vertical-align:middle;">
        <span style="display:block;width:16px;height:16px;background:#fff;border:1px solid #ccc;border-radius:50%;position:absolute;top:1px;left:1px;transition:left 0.2s;"></span>
      </span>
      `
  }

  // Initialize the toggle on page load
  async function initCartPageToggle() {
    const toggle = document.getElementById(TOGGLE_ID)
    if (!toggle) return
    
    // Check if warranty is already in cart
    const hasWarranty = await checkWarrantyInCart()
    renderToggle(hasWarranty)
    
    // Set state based on actual cart contents
    toggle.setAttribute("data-has-warranty", hasWarranty ? "true" : "false")
    toggle.setAttribute("aria-pressed", hasWarranty ? "true" : "false")
    
    // Bind click handler
    toggle.addEventListener("click", handleToggleClick)
    
    console.log("[CartPageWarranty] Initialized with state:", hasWarranty ? "ON" : "OFF")
  }

  // Run on DOM content loaded
  document.addEventListener("DOMContentLoaded", initCartPageToggle)
})();
